import { UserBookingDetailsQuery } from '@website/types/graphqlOperations';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMemo } from 'react';
import InvoiceRowItem from './InvoiceRowItem';

export default function BalancePaymentSection({
  booking,
  balanceDueDate,
}: {
  booking: Pick<UserBookingDetailsQuery['booking'], 'invoiceSummary'>;
  balanceDueDate: string;
}) {
  const balanceLine = useMemo(() => {
    return booking.invoiceSummary.find(
      (summary) => summary.type === 'BALANCE_DUE',
    );
  }, [booking.invoiceSummary]);

  if (!balanceLine) {
    return (
      <InvoiceRowItem
        className="fw-bold"
        lineText="Balance Due"
        amountZD={0}
        currency={booking.invoiceSummary[0]?.amount?.currency}
        trClassName="border-top "
        amountClassName="fw-bold"
      />
    );
  }

  return (
    <>
      <InvoiceRowItem
        className="fw-bold text-danger"
        lineText={`Balance (due by ${balanceDueDate})`}
        amountZD={balanceLine?.amount?.amountZD}
        currency={balanceLine?.amount?.currency}
        trClassName="border-top "
        amountClassName="fw-bold text-danger"
      />
    </>
  );
}
